/* eslint-disable max-classes-per-file */
import _ from "lodash";
import { Cellstyle, ClickableCell, HotCell, NumericCellChangeArg } from "~app/common/components/hot-doc/hotdoc/cell";
import { HotDoc } from "~app/common/components/hot-doc/hotdoc/doc";
import { ProduktFordelningsmatrisTyper } from "~app/common/models/constants";
import { ProduktLangdfordelningDTO } from "~app/common/models/produkt/ProduktLangdfordelningDTO";

export class AddEditRowCell extends ClickableCell {

    constructor(flags?: Cellstyle, settings?: any, private readonly icon?: string, private readonly onHandle?: () => void) {
        super(flags, settings);
    }

    onClick = (hotDoc: HotDoc): void => {
        if (this.onHandle) {
            this.onHandle();
        }
    };

    protected genHtml(): string {
        return `<button class='btn btn-icon icon-btn accordion-trigger' type='button' ignore-readonly>` +
            `<i class="${this.icon ? this.icon : "fas fa-edit"}"></i>` +
            `</button>`;
    }
}

export class FordelningsmatrisCell extends HotCell {
    value: number;
    langdFordelning: ProduktLangdfordelningDTO;

    constructor(
        langdFordelning: ProduktLangdfordelningDTO,
        flags?: Cellstyle,
        onHandle?: (newValue: NumericCellChangeArg) => void) {

        super(flags, null, onHandle);
        this.langdFordelning = langdFordelning;
        this.value = Math.round(langdFordelning.andel);
    }

    static format(value: number): string {
        const val = _.isNumber(value) ? Math.round(value) : 0;
        return `${val.toLocaleString("en").replace(/,/g, " ")}`;
    }

    validate(value: any): boolean {
        if (_.isNumber(value) || !isNaN(value)) {
            this.langdFordelning.andel = value;

            return true;
        }
        return false;
    }

    override onDelete(): void { }

    protected genHtml(): string {
        return FordelningsmatrisCell.format(this.value);
    }

    protected applyStyle(td: HTMLTableCellElement, cellProperties: any) {
        td.classList.add(HotCell.hotNumber);
        if (this.langdFordelning.typ === ProduktFordelningsmatrisTyper.forbjuden) {
            cellProperties.readOnly = true;
            td.classList.add("fordelningsmatris-forbjuden");
        } else if (this.langdFordelning.typ === ProduktFordelningsmatrisTyper.min) {
            td.classList.add("fordelningsmatris-min");
        } else if (this.langdFordelning.typ === ProduktFordelningsmatrisTyper.max) {
            td.classList.add("fordelningsmatris-max");
        }

        if (this.value < 0 || this.value > 100) {
            td.classList.add("hot-alert");
        }
    }
}

export class FordelningsmatrisSumCell extends HotCell {
    value: number;
    maxHundred: boolean;

    constructor(rawvalue: number, maxHundred: boolean) {

        super();
        this.value = Math.round(rawvalue);
        this.maxHundred = maxHundred;
    }

    static format(value: number): string {
        const val = _.isNumber(value) ? Math.round(value) : 0;
        return `${val.toLocaleString("en").replace(/,/g, " ")}%`;
    }

    validate(value: any): boolean {
        return _.isNumber(value) || !isNaN(value);
    }

    override onDelete(): void { }

    protected genHtml(): string {
        return FordelningsmatrisSumCell.format(this.value);
    }

    protected applyStyle(td: HTMLTableCellElement, cellProperties: any) {
        td.classList.add(HotCell.hotNumber);
        td.classList.add("hot-readonly");
        cellProperties.readOnly = true;

        if (this.maxHundred && (this.value < 0 || this.value > 100)) {
            td.classList.add("hot-alert");
        }
    }
}
